import { render, staticRenderFns } from "./RedPackageBase.vue?vue&type=template&id=0d12e449&scoped=true&"
import script from "./RedPackageBase.vue?vue&type=script&lang=js&"
export * from "./RedPackageBase.vue?vue&type=script&lang=js&"
import style0 from "./RedPackageBase.vue?vue&type=style&index=0&id=0d12e449&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d12e449",
  null
  
)

export default component.exports